export type DocumentTheme = 'minimal' | 'corporate' | 'luxury' | 'construction' | 'executive';
export type BrandDensity = 'comfortable' | 'compact';
export type TypographyPreset = 'geist' | 'inter' | 'plex';

export interface BusinessIdentity {
  branding_version: number;
  
  // ── Tab 1: Identity ────────────────────────
  company_name: string;
  legal_name?: string;
  
  // Exact immutable public URLs (versioned)
  logo_url?: string;       
  favicon_url?: string;    
  
  // Validated Hex codes only
  brand_color?: string;    
  accent_color?: string;   
  subitem_heading_bg_color?: string;
  subitem_row_bg_color?: string;
  subitem_text_color?: string;

  // ── Tab 2: Documents ───────────────────────
  theme_mode?: 'light' | 'dark' | 'system';
  document_theme?: DocumentTheme;
  density?: BrandDensity;
  typography_preset?: TypographyPreset;
  
  // Exact immutable public URLs (versioned)
  signature_url?: string;  
  seal_url?: string;       
  
  invoice_footer?: string;
  
  print_preferences?: {
    paper_size?: 'A4';
    show_watermark?: boolean;
    show_qr_payment?: boolean;
  };

  // ── Tab 3: Financial ───────────────────────
  gstin?: string;
  pan?: string;
  address?: string;
  contact_phone?: string;
  contact_email?: string;
  website?: string;
  social_instagram?: string;
  social_twitter?: string;
  social_linkedin?: string;
  social_facebook?: string;
  
  bank_details?: {
    account_name: string;
    bank_name: string;
    account_number: string;
    ifsc: string;
    upi_id?: string;
  };
}

export const DEFAULT_BUSINESS_IDENTITY: BusinessIdentity = {
  branding_version: 1,
  company_name: 'Dcode Interiors',
  legal_name: 'DCODE Private Limited',
  contact_phone: '+91 96338 60898',
  contact_email: 'info@dcodeinteriors.com',
  address: 'KC Arcade, 2nd Floor, Near TV Centre, CSEZ, Ernakulam, Kerala – 682037',
  document_theme: 'minimal',
  density: 'comfortable',
  typography_preset: 'inter',
  theme_mode: 'light',
  subitem_heading_bg_color: '#f8fafc',
  subitem_row_bg_color: '#f8fafc',
  subitem_text_color: '#475569',
  print_preferences: {
    paper_size: 'A4',
    show_watermark: false,
    show_qr_payment: false
  }
};
